import { ActivityDataGrid } from "src/components/ActivityDataGrid/ActivityDataGrid";
import { EmptyRowsFallback } from "src/components/Grid/EmptyRowsFallback";
import { useTranslation } from "react-i18next";
import { useActivitiesColumns } from "./useActivitiesColumns";
import { useProductMetadataContext } from "src/context/Product/Metadata/useProductMetadata";
import { OrganizationActivitiesFormData, getVisibleShares } from "./activitiesSpace";
import { useFoodpilotContext } from "src/context/FoodpilotContext";

export type OrganizationsListProps = {
    activities: OrganizationActivitiesFormData;
    onActivitiesUpdate: (value: OrganizationActivitiesFormData) => void;
    toggleEditMode: boolean;
};

export const OrganizationsList = (props: OrganizationsListProps) => {
    const { t } = useTranslation();
    const { activities, toggleEditMode, onActivitiesUpdate } = props;
    const {
        product: { shares = [], ownedBy },
    } = useProductMetadataContext();
    const { selectedCompany } = useFoodpilotContext();
    const visibleShares = getVisibleShares(shares, selectedCompany?.id, selectedCompany?.id === ownedBy?.id);
    const columns = useActivitiesColumns(activities, onActivitiesUpdate, toggleEditMode);

    return (
        <ActivityDataGrid
            columns={columns}
            property="productOrganizationActivityDatas"
            data={visibleShares}
            enablePagination={false}
            renderEmptyRowsFallback={() => (
                <EmptyRowsFallback
                    message={t("product.activity_data.no_organizations_to_display", "No organizations to display")}
                />
            )}
        />
    );
};
